import { render } from "./MovimentacaoForm.vue?vue&type=template&id=5029d65c"
import script from "./MovimentacaoForm.vue?vue&type=script&lang=js"
export * from "./MovimentacaoForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__